// utils/deviceDetector.js
/**
 * Utility to detect device type for responsive behavior
 */

// Check if the device is a mobile device
export const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // Regular expression for mobile devices
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    
    // Check viewport width as an additional criterion
    const isMobileWidth = window.innerWidth <= 768;
    
    return mobileRegex.test(userAgent) || isMobileWidth;
  };
  
  // Check if the device is a desktop
  export const isDesktopDevice = () => {
    return !isMobileDevice();
  };
  
  // Get the current device type
  export const getDeviceType = () => {
    return isMobileDevice() ? 'mobile' : 'desktop';
  };
  
  export default {
    isMobileDevice,
    isDesktopDevice,
    getDeviceType
  };